import React from 'react'
import {CreditList} from 'components/Credits/index'
import { Modal } from 'antd'
import styled from '@emotion/styled'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';

const Header = styled.div`
	display: grid;
	grid-template-columns: 6rem 1rem 4rem 1rem;
	grid-gap: 1rem;
	align-items: center;
	text-align: center;
	.anticon {
		color: #999;
	}
`

const TransactionsDetailModal = ({data, loading, detailsDate, setDetailsModalVisible, transactions, fetchTransactionDetailsMonth, modalVisible }) => {

	const StyledCreditsList = styled.ul({
		minWidth: 600,
		maxHeight: 400,
		overflowY: 'auto',
	  })

  const checkValidDetailDate = dateObj => {
    let res = false;
    transactions.forEach(row => {
      let newDate = new Date(row.date)
      if (dateObj.getMonth() == newDate.getMonth() && dateObj.getFullYear() == newDate.getFullYear())
        res = true
    });
    return res;
  }

  return (
    <>
    	<Modal
			title={
			<Header>
				<span>Usage Report</span>
				<CaretLeftOutlined onClick={() => {
					let dateObj = new Date(detailsDate);
					let date = new Date(dateObj.setMonth(dateObj.getMonth() - 1));
					if (checkValidDetailDate(date))
						fetchTransactionDetailsMonth(date)
					}
				} />

				{new Date(detailsDate).getMonth() + 1 + '-' + new Date(detailsDate).getFullYear()}

				<CaretRightOutlined onClick={() => {
					let dateObj = new Date(detailsDate);
					let date = new Date(dateObj.setMonth(dateObj.getMonth() + 1));
					if (checkValidDetailDate(date))
						fetchTransactionDetailsMonth(date)
					}
				} />
			</Header>
				}
				width={700}
				visible={modalVisible}
				onCancel={() => setDetailsModalVisible(false)}
				footer={null}
			>
			<StyledCreditsList>	
          	<CreditList managementMode={false} data={data} loading={loading} />	
		  </StyledCreditsList>		
		</Modal>
    </>
  )
}

export default TransactionsDetailModal